import { CacheData, InstantConfigCacheStorageService } from '../models';

export class EmptyInstantConfigCacheStorage implements InstantConfigCacheStorageService {
	get(id: string): CacheData | undefined {
		return undefined;
	}

	set(data: CacheData): void {}
}
